import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../translations';
import skipActivityIcon from 'assets/svg/skip-activity-icon.svg';
import style from './SkipActivityButton.module.scss';
import { skipRecordingActivity } from 'store/actions/activity';

const getActivityType = (currentRoundIndex, activities, isLoading) => {
  if (currentRoundIndex < 0 || !activities || !activities.length) return null;
  if (isLoading && currentRoundIndex >= 0) return null;
  const currentRound = activities[currentRoundIndex];
  return currentRound.type;
};

export const SkipActivityButton = ({
  currentRoundIndex,
  activities,
  isLoading,
  endRound,
  skipRecordingActivity,
  isCountersFlipCard,
  contentScaling
}) => {
  const activityType = getActivityType(currentRoundIndex, activities, isLoading);

  const skipActivityClick = () => {
    const skippableActivityTypes = ['VoiceRecorder', 'WordRecorder', 'SoundRecorder'];
    if (skippableActivityTypes.includes(activityType)) {
      skipRecordingActivity(true);
    }
    endRound();
  };

  const getButtonTabIndex = () => (activityType === 'Counters' && isCountersFlipCard ? 1 : 0);

  return (
    <div className={style.skipBtnContainer}>
      <button
        id="skip-button"
        className={['gss-button', style.skipBtn, style[`skipBtn${contentScaling}`]].join(' ')}
        onClick={() => skipActivityClick()}
        aria-label={t('SkipActivity')}
        tabIndex={getButtonTabIndex()}
      >
        <img src={skipActivityIcon} alt="" />
      </button>
    </div>
  );
};

SkipActivityButton.propTypes = {
  currentRoundIndex: PropTypes.number,
  activities: PropTypes.array,
  isLoading: PropTypes.bool,
  endRound: PropTypes.func,
  skipRecordingActivity: PropTypes.func,
  isCountersFlipCard: PropTypes.bool,
  contentScaling: PropTypes.number
};

const mapStateToProps = state => ({
  isLoading: state.ui.loading,
  currentRoundIndex: state.activity.currentRoundIndex,
  activities: state.activity.activities,
  isCountersFlipCard: state.activity.isCountersFlipCard
});

export default connect(mapStateToProps, { skipRecordingActivity })(SkipActivityButton);
